import changePreCheckoutCurrencies from "../../../../graphQl/mutations/changePreCheckoutCurrencies";

export const changePreCheckoutCurrenciesQuery = async ({dispatch, commit, rootGetters}, payload) => {
    let changeLangData;
    commit('app/toggleLoading', null, {root: true});

    const organizationId = rootGetters['app/getSelectedOrganization'].id;
    const variables = {
        organizationId,
        ...payload,
    };

    try {
        changeLangData = await dispatch('app/request', {
            type: 'mutation',
            gql: changePreCheckoutCurrencies,
            variables,
        }, {root: true});
    } catch (error) {
        commit('app/toggleLoading', null, {root: true});
        return error;

    }

    if (changeLangData.message) {
        throw changeLangData.message;
    }

    if (changeLangData.errors) {
        throw changeLangData.errors;
    }
    commit('app/toggleLoading', null, {root: true});
    const {
        data: {
            changePreCheckoutCurrencies: changePreCheckoutCurrenciesResponse,
        },
    } = changeLangData;
    return changePreCheckoutCurrenciesResponse;

};
